import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import {
	MobileActivityReportResource,
	MobileActivityReportResponse,
	MobileActivityQuery,
} from "api/resource/mobile-activity";
import { loginReset } from "./authentication";

/**
 * Mobile Statistics report (mobileActivity.cfm) — MAX-3888. Read-only; the endpoint returns the full
 * date-filtered set (paged client-side by the shared Table). Keeps rows + total (total drives the
 * results header).
 */
export interface MobileActivityState {
	loading?: boolean;
	error?: string | null;
	loaded: boolean;
	rows: MobileActivityReportResource[];
	total: number;
}

const initialState: MobileActivityState = {
	loaded: false,
	rows: [],
	total: 0,
};

const fetchMobileActivity = createAsyncThunk(
	"mobileActivity/fetch",
	async (payload: MobileActivityQuery, thunkAPI) => {
		thunkAPI.dispatch(mobileActivityLoading());
		const result = api.getMobileActivity(payload);
		result
			.then((response) => thunkAPI.dispatch(mobileActivityLoaded(response)))
			.catch((error) => thunkAPI.dispatch(mobileActivityFailed(error)));
		return result;
	}
);

export const mobileActivitySlice = createSlice({
	name: "mobileActivity",
	initialState,
	reducers: {
		mobileActivityLoading(state) {
			state.loading = true;
		},
		mobileActivityLoaded(state, action: PayloadAction<MobileActivityReportResponse>) {
			state.loading = false;
			state.error = null;
			state.loaded = true;
			state.rows = action.payload.rows;
			state.total = action.payload.total;
		},
		mobileActivityFailed(state, action: PayloadAction<any>) {
			state.loading = false;
			state.error = action.payload && action.payload.message;
		},
	},
	extraReducers(builder) {
		builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
	},
});

export const {
	mobileActivityLoading,
	mobileActivityLoaded,
	mobileActivityFailed,
} = mobileActivitySlice.actions;

export { fetchMobileActivity };
